import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';

import {
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNil, isNotNil } from '@web/utils';
import {
  OrderRefundCollectionItem,
  PublicInvoiceDataSourceService,
  RefundStatusComponent,
  RefundTypeComponent,
} from '@web/shared/module/shop';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-public-order-refund-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    RefundStatusComponent,
    RefundTypeComponent,
    NoDataComponent,
    Button,
    Tooltip,
  ],
  templateUrl: './public-order-refund-list-custom-cell-template.component.html',
  styleUrl: './public-order-refund-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderRefundListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<OrderRefundCollectionItem, never>>();
  /* prettier-ignore */
  public readonly model = input.required<OrderRefundCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<OrderRefundCollectionItem>;
  protected readonly isNotNil = isNotNil;

  private readonly invoiceDataSource = inject(PublicInvoiceDataSourceService);

  public handleDownloadInvoiceClick(): void {
    const number = this.model().number;

    if (isNil(number)) {
      return;
    }

    this.invoiceDataSource.downloadRefundInvoice(number).subscribe();
  }
}
